import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * The action to update the flags behind the checkboxes in the txp options UI
 */
export default select({
    optionState: function () { return store; },
})(action('updateTxpFlag')(function updateTxpFlag(flagName, enabled, state) {
    var optionState = state.optionState;
    if (flagName == 'EventsFromEmailEnabled' || flagName == 'CreateEventsFromEmailAsPrivate') {
        optionState[flagName] = enabled;
    }
    else {
        optionState.Events[flagName] = enabled;
    }
}));
//# sourceMappingURL=updateTxpFlag.js.map